import React, { useState, useEffect, useRef } from 'react';
import {ProcessFlow} from "../components/ProcessFlow"
import {Step1Plan} from "../components/Step1Plan"
import {Step2Generate} from "../components/Step2Generate"
import {Step3Deploy} from "../components/Step3Deploy"
import {Step4Measure} from "../components/Step4Measure"
import {Step5Optimize} from "../components/Step5Optimize"
import {Navbar} from "../components-sub/Navbar"
import {Hero} from "../components-sub/Hero"
import {InnovationHub} from "../components-sub/InnovationHub"
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import defaultData from "../demoDefaultData.json";
import configData from "../config.json";
import { getToken } from "../utils/auth";
import AutoResizeTextarea from '../components-sub/AutoResizeTextarea';


const FadeIn = ({ children, className = "" }) => (
  <div className={`animate-fade-in ${className}`}>
    {children}
  </div>
);


export default function MIA({
  current_balance,
  setCurrentBalance,
  role,
  setRole,
  audioUrl,
  setAudioUrl,
  audioText,
  setAudioText,
  bannerUrl,
  setBannerUrl,
  videoUrl,
  setVideoUrl,
  animateBanner,
  setAnimateBanner,
  aspectBannerRatio,
  setAspectBannerRatio,
  aspectVideoRatio,
  setAspectVideoRatio,
  templateBanner,
  setTemplateBanner,
  selectedCategory,
  setSelectedCategory,
  AssetCard,
  spinning,
  setSpinning,
  fetchAudioTextStatus,
  setFetchAudioTextStatus,
  fetchonlyAudioStatus,
  setFetchonlyAudioStatus,
  allGenratedBanners,
  setAllGenratedBanners,
  allGenratedVideos,
  setAllGenratedVideos,
  allGenratedAudios,
  setAllGenratedAudios,
  allUploadedAudios,
  setAllUploadedAudios,
}) {
  const [currentStep, setCurrentStep] = useState(1);
  const simulatorRef = useRef(null);
  const [tailwindLoaded, setTailwindLoaded] = useState(false);
  const notify = (message, style) => {
          if (style === "success") {
          toast.success(message, {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
              icon: false, // remove the icon
          });
          } else {
          toast.error(message, {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
              icon: false, // remove the icon
          });
          }
      };

    const [language, setLanguage] = useState('English');

    const [logoUrl, setlogoUrl] = useState(null);
    const [logos, setLogos] = useState([]);

    const [audioData, setAudio] = useState(null);
    const [bannerData, setBanner] = useState(null);

    const [CompanyName, setCompanyName] = useState('');

    const [fetchAudioFile, setFetchAudioFile] = useState(false)
    // const [fetchAudioTextStatus, setFetchAudioTextStatus] = useState(false)
    // const [fetchonlyAudioStatus, setFetchonlyAudioStatus] = useState(false)

    const [fetchBannerFile, setFetchBannerFile] = useState(false)
    const [fetchVideoFile, setFetchVideoFile] = useState(false)

    

    const [brandColors, setBrandColors] = useState(['#1E3A8A', '#3B82F6', '#F97316']);

    const [marketingGoals, setMarketingGoals] = useState([]);
    const [voice, setVoice] = useState('');
    const [targetAudience, setTargetAudience] = useState([]);
    const [vibeAndTone, setVibeAndTone] = useState([]);

    const [marketingGoalsDropdown, setMarketingGoalsDropdown] = useState([]);
    const [targetAudienceDropdown, setTargetAudienceDropdown] = useState([]);
    const [vibeAndToneDropdown, setVibeAndToneDropdown] = useState([]);
    const [voicesDropdown, setVoicesDropdown] = useState([]);

    const [editableTextAudio, setEditableTextAudio] = useState("");
    
    const [productImageUrl, setProductImageUrl] = useState("");
    const [campaignDescription, setCampaignDescription] = useState("");

    const [campaigns, setCampaigns] = useState(null);

// upload asset data states


    const [uploadBannerID, setUploadBannerID] = useState(null)
    const [uploadAudioID, setUploadAudioID] = useState(null)
    const [uploadVideoID, setUploadVideoID] = useState(null)
    const [selectedBanner, setSelectedBanner] = useState(null);
    const [selectedVideo, setSelectedVideo] = useState(null);
    const [selectedAudio, setSelectedAudio] = useState(null);
    const [screens, setScreens] = useState([]);
    

    const [screenData, setScreenData] = useState(null)

    const [takeOverScreenStatus, setTakeOverScreenStatus] = useState(null)

    const ChangeFetchAudioFileStatus = (status) => {
        setFetchAudioFile(status)
    };

    const ChangeFetchBannerFileStatus = (status) => {
        setFetchBannerFile(status)
    };

    const ChangeFetchVideoFileStatus = (status) => {
        setFetchVideoFile(status)
    };


  useEffect(() => {
    const script = document.createElement('script');
    script.src = "https://cdn.tailwindcss.com";
    script.async = true;
    script.onload = () => setTailwindLoaded(true);
    document.head.appendChild(script);
  }, []);
  useEffect(() => {
  document.body.style.overflowY = 'auto';
  return () => {
    document.body.style.overflowY = '';
  };
}, []);

  useEffect(() => {
    const fetchBalance = async () => {
      const token = getToken();

      const res = await fetch(`${configData.DEMO_URL}/FetchBalance`, {
        method: "GET",
        headers: {
          "x-access-token": token,
          "Content-Type": "application/json",
        },
      });
      // optional:
      const data = await res.json();
      setCurrentBalance(data.current_balance);
      setRole(data.role)

      setMarketingGoals(data.marketing_goals);
      setTargetAudience(data.target_audience);
      setVibeAndTone(data.vibe_and_tone);
      const safeLogos = Array.isArray(data.logos) ? data.logos : [];
      setLogos(safeLogos);
      setlogoUrl(safeLogos[0] || "");
      setCompanyName(data.company_name);
      setLanguage(data.language);
      setVoicesDropdown(data.voices_dropdown || []);
      setVoice(data.voice || (data.voices_dropdown?.[0]?.value ?? ''));
      setMarketingGoalsDropdown(data.marketing_goals_dropdown);
      setTargetAudienceDropdown(data.target_audience_dropdown);
      setVibeAndToneDropdown(data.vibe_and_tone_dropdown);

      const resCampaigns = await fetch(`${configData.DEMO_URL}/FetchCampaigns`, {
        method: "GET",
        headers: {
          "x-access-token": token,
          "Content-Type": "application/json",
        },
      });
      const dataCampaigns = await resCampaigns.json();
      if(dataCampaigns.campaigns && dataCampaigns.campaigns.length > 0) {
        setCampaigns(dataCampaigns.campaigns);
      }
    };

    fetchBalance();
  }, []);

  useEffect(() => {
    if (!logoUrl) return;
    setLogos((prev) => {
      const safePrev = Array.isArray(prev) ? prev : [];
      return safePrev.includes(logoUrl) ? safePrev : [logoUrl, ...safePrev];
    });
  }, [logoUrl]);

  if (!tailwindLoaded) return null;


  const handleStepChange = (step) => {
    setCurrentStep(step);
  };

  const handleAdvance = (nextStep) => {
    setCurrentStep(nextStep);
    // Smooth scroll to simulator to show change
    if(simulatorRef.current) {
      simulatorRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };

  const renderSimulatorContent = () => {
    switch(currentStep) {
      case 1: return <Step1Plan 
        audioData= {audioData}
        setAudio={setAudio}
        bannerData={bannerData}
        setBanner={setBanner}
        CompanyName={CompanyName}
        setCompanyName={setCompanyName}
        language = {language}
        setLanguage = {setLanguage}
        setlogoUrl = {setlogoUrl}
        logoUrl = {logoUrl}
        logos = {logos}
        setLogos = {setLogos}
        marketingGoals = {marketingGoals}
        setMarketingGoals = {setMarketingGoals}
        voice = {voice}
        setVoice = {setVoice}
        targetAudience = {targetAudience}
        setTargetAudience = {setTargetAudience}
        vibeAndTone = {vibeAndTone}
        setVibeAndTone = {setVibeAndTone}
        marketingGoalsDropdown={marketingGoalsDropdown}
        targetAudienceDropdown={targetAudienceDropdown}
        vibeAndToneDropdown={vibeAndToneDropdown}
        voicesDropdown={voicesDropdown}
        brandColors = {brandColors}
        setBrandColors={setBrandColors}
        FadeIn= {FadeIn} 
        notify={notify} 
        onGenerate={() => handleAdvance(2)} />;
      case 2: return <Step2Generate
        marketingGoals={marketingGoals}
        targetAudience={targetAudience}
        vibeAndTone={vibeAndTone}
        setCurrentBalance={setCurrentBalance}
        AutoResizeTextarea={AutoResizeTextarea}
        fetchAudioFileStatus = {fetchAudioFile} 
        spinning={spinning}
        setSpinning={setSpinning}
        fetchAudioTextStatus = {fetchAudioTextStatus}
        fetchonlyAudioStatus = {fetchonlyAudioStatus}
        fetchBannerFileStatus = {fetchBannerFile}
        fetchVideoFileStatus = {fetchVideoFile}
        ChangeFetchAudioFileStatus = {ChangeFetchAudioFileStatus} 
        setFetchAudioTextStatus = {setFetchAudioTextStatus}
        setFetchonlyAudioStatus = {setFetchonlyAudioStatus}
        ChangeFetchBannerFileStatus = {ChangeFetchBannerFileStatus}
        ChangeFetchVideoFileStatus = {ChangeFetchVideoFileStatus}
        defaultCampaigns = {campaigns !== null ? campaigns : (defaultData[language] || defaultData["English"])}
        language = {language}
        audioData= {audioData} 
        bannerData={bannerData}
        audioUrl = {audioUrl}
        setAudioUrl = {setAudioUrl}
        audioText = {audioText}
        setAudioText = {setAudioText}
        bannerUrl = {bannerUrl}
        setBannerUrl = {setBannerUrl}
        videoUrl = {videoUrl}
        setVideoUrl = {setVideoUrl}
        animateBanner={animateBanner}
        setAnimateBanner={setAnimateBanner}
        aspectBannerRatio={aspectBannerRatio}
        setAspectBannerRatio={setAspectBannerRatio}
        aspectVideoRatio={aspectVideoRatio}
        setAspectVideoRatio={setAspectVideoRatio}
        templateBanner={templateBanner}
        setTemplateBanner={setTemplateBanner}
        selectedCategory={selectedCategory}
        setSelectedCategory={setSelectedCategory}
        setUploadAudioID={setUploadAudioID}
        setUploadBannerID={setUploadBannerID}
        setUploadVideoID={setUploadVideoID}
        editableTextAudio={editableTextAudio}
        setEditableTextAudio={setEditableTextAudio}
        productImageUrl={productImageUrl}
        setProductImageUrl={setProductImageUrl}
        campaignDescription={campaignDescription}
        setCampaignDescription={setCampaignDescription}
        allGenratedBanners={allGenratedBanners}
        setAllGenratedBanners={setAllGenratedBanners}
        allGenratedVideos={allGenratedVideos}
        setAllGenratedVideos={setAllGenratedVideos}
        allGenratedAudios={allGenratedAudios}
        setAllGenratedAudios={setAllGenratedAudios}
        allUploadedAudios={allUploadedAudios}
        setAllUploadedAudios={setAllUploadedAudios}
        selectedBanner={selectedBanner}
        setSelectedBanner={setSelectedBanner}
        selectedVideo={selectedVideo}
        setSelectedVideo={setSelectedVideo}
        selectedAudio={selectedAudio}
        setSelectedAudio={setSelectedAudio}
        FadeIn= {FadeIn} 
        AssetCard={AssetCard}
        notify={notify} 
        onDeploy={() => handleAdvance(3)}
        />;
      case 3: return <Step3Deploy 
        FadeIn= {FadeIn} 
        allGenratedBanners={allGenratedBanners}
        allGenratedVideos={allGenratedVideos}
        allUploadedAudios={allUploadedAudios}
        bannerUrl = {bannerUrl}
        videoUrl = {videoUrl}
        audioUrl = {audioUrl}
        uploadAudioID={uploadAudioID}
        uploadBannerID={uploadBannerID}
        uploadVideoID={uploadVideoID}
        setScreenData = {setScreenData}
        screens = {screens}
        setScreens = {setScreens}
        notify={notify}
         />;
      case 4: return <Step4Measure 
        FadeIn={FadeIn}
        takeOverScreenStatus={takeOverScreenStatus}
        setTakeOverScreenStatus={setTakeOverScreenStatus}
        screenData = {screenData}
        setScreenData = {setScreenData}
        notify={notify}
      />;
      case 5: return <Step5Optimize FadeIn={FadeIn}/>;
      default: return null;
    }
  };
  

  return (
    <div className="min-h-screen bg-white font-sans text-slate-900 scroll-smooth">
    <ToastContainer
            position="top-center"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
            />
      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .animate-fade-in {
          animation: fadeIn 0.5s ease-out forwards;
        }
        /* Hide scrollbar for clean internal scrolling */
        .custom-scrollbar::-webkit-scrollbar {
          width: 4px;
        }
        .custom-scrollbar::-webkit-scrollbar-track {
          background: transparent;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb {
          background-color: #BFDBFE;
          border-radius: 20px;
        }
      `}</style>
      <Navbar 
      current_balance={current_balance}
      role={role}
      />
      <Hero />
      
      <main>
        <ProcessFlow currentStep={currentStep} setStep={handleStepChange} />
        
        <section id="simulator" ref={simulatorRef} className="py-16 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 bg-blue-50/50">
        <div className="bg-white rounded-2xl shadow-xl border border-blue-200 flex flex-col transition-all duration-300">
            {renderSimulatorContent()}
        </div>
        </section>


        <InnovationHub />
      </main>

      <footer className="bg-blue-900 text-blue-200 py-12 text-center border-t border-blue-800">
        <div className="max-w-7xl mx-auto px-4">
            <h2 className="text-2xl font-bold text-white mb-4">Catch MIA</h2>
            <p className="mb-8">Automating the physical retail experience with generative intelligence.</p>
            <div className="text-sm">
                Catch Retail Inc. – All Rights Reserved Copyright © 2025
            </div>
        </div>
      </footer>
    </div>
  );
}